import CompaniesReactSortableTreeContainer from './companiesReactSortableTree.container';

export default CompaniesReactSortableTreeContainer;
